import React from "react";
import sanityConfig from "services/sanity-config";
import Link from "helpers/link";
import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";

const getGatsbyImage = (img, width) => {
	return getGatsbyImageData(
		img,
		{ width: width || 800 },
		sanityConfig()
	);
};

const Image = ({ image, width, className, alt, to, ...other }) => {
	if (!image?.asset && !image?._ref) return null;

	return (
		to ?
			<Link to={to}>
				<GatsbyImage
					image={getGatsbyImage(image, width)}
					alt={image?.alt ?? alt ?? ""}
					className={className}
					{...other}
				/>
			</Link> :
			<GatsbyImage
				image={getGatsbyImage(image, width)}
				alt={image?.alt ?? alt ?? ""}
				className={className}
				{...other}
			/>
	);
};

export default Image;
